export enum AlignItems {
  flexStart = 'flex-start',
  center = 'center',
  flexEnd = 'flex-end',
}

export const AlignItemsMap = new Map([
  [AlignItems.flexStart, 'Left'],
  [AlignItems.center, 'Center'],
  [AlignItems.flexEnd, 'Right'],
]);

export const AlignItemsIconsMap = new Map([
  [AlignItems.flexStart, 'alignleft'],
  [AlignItems.center, 'aligncenter'],
  [AlignItems.flexEnd, 'alignright'],
]);

export const ALIGN_ITEMS_LOOKUP = [AlignItems.flexStart, AlignItems.center, AlignItems.flexEnd].map(value => {
  return { value: value, icon: AlignItemsIconsMap.get(value), hint: AlignItemsMap.get(value) };
});

export enum VerticalAlignItems {
  start = 'start',
  center = 'center',
  end = 'end',
}

export const VerticalAlignItemsMap = new Map([
  [VerticalAlignItems.start, 'Top'],
  [VerticalAlignItems.center, 'Middle'],
  [VerticalAlignItems.end, 'Bottom'],
]);

export const VerticalAlignItemsIconsMap = new Map([
  [VerticalAlignItems.start, 'equal'],
  [VerticalAlignItems.center, 'equal'],
  [VerticalAlignItems.end, 'equal'],
]);

export const VERTICAL_ALIGN_ITEMS_LOOKUP = [
  VerticalAlignItems.start,
  VerticalAlignItems.center,
  VerticalAlignItems.end,
].map(value => ({
  value,
  icon: VerticalAlignItemsIconsMap.get(value),
  hint: VerticalAlignItemsMap.get(value),
  elementAttr: { 'data-align': value }
}));
